import { render, staticRenderFns } from "./EditableTextElement.vue?vue&type=template&id=58edfb58&scoped=true"
import script from "./EditableTextElement.vue?vue&type=script&lang=js"
export * from "./EditableTextElement.vue?vue&type=script&lang=js"
import style0 from "./EditableTextElement.vue?vue&type=style&index=0&id=58edfb58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58edfb58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58edfb58')) {
      api.createRecord('58edfb58', component.options)
    } else {
      api.reload('58edfb58', component.options)
    }
    module.hot.accept("./EditableTextElement.vue?vue&type=template&id=58edfb58&scoped=true", function () {
      api.rerender('58edfb58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/EditableTextElement.vue"
export default component.exports